/**
 * Presence — docs/05-DATA-MODEL.md §3, SRS D2.
 *
 * Cursors, names, and the tool each person is holding. NEVER persisted: this lives in
 * memory for the length of a session and disappears with it.
 */
/** SRS D2 — cursors fade after this long without movement. */
export const CURSOR_FADE_MS = 3000;
/** SRS G3 — a raised hand clears itself after this long. */
export const RAISE_HAND_AUTO_CLEAR_MS = 60_000;
/** SRS D2 — the teacher is always labelled "Teacher", students by first name. */
export function presenceLabel(state) {
    if (state.role === 'teacher' || state.role === 'admin')
        return 'Teacher';
    return state.displayName.trim().split(/\s+/)[0] ?? state.displayName;
}
/** Remote cursors interpolate towards their target so they never teleport. */
export function interpolateCursor(from, to, t) {
    const clamped = Math.min(1, Math.max(0, t));
    return {
        x: from.x + (to.x - from.x) * clamped,
        y: from.y + (to.y - from.y) * clamped,
    };
}
//# sourceMappingURL=awareness.js.map